import React, {useEffect, useState} from "react"
import cx from "classnames"
import styles from "./StaticTopics.module.css"
import Image from "next/image";
import Link from "next/link";
import HoverLink1 from "../HoverLink1/HoverLink1";
import {useRouter} from "next/router";

const StaticTopics = ({isInView, divRef, title, paragraph, imgaSrc, link, linkTitle}) => {
    const [isEn, setIsEn] = useState(false)
    const router = useRouter()

    useEffect(() => {
        if (router.pathname.includes("/en")) {
            setIsEn(true)
        } else {
            setIsEn(false)
        }
    }, [router])
    return (
        <div
            style={{
                opacity: isInView ? 1 : 0,
                transition: "all ease 1400ms"
            }}
            className={cx("w-100", "d-flex", "flex-column", "align-items-start", "justify-content-center")}>
            <h2
                style={{
                    transform: isInView ? "none" : "translateX(100px)",
                    opacity: isInView ? 1 : 0,
                    transition: "all ease 1400ms",
                    fontSize: title.length > 30 ? "24px" : "32px"
                }}
                className={cx(styles.rowTitle, isEn ? "gilroyFontFamily" : "", "mb-3")}>{title}</h2>
            <div
                className={cx(isEn ? styles.contentWrapperEn : styles.contentWrapper, "d-flex", "w-100", "position-relative", "align-items-center", "flex-column-reverse", "flex-lg-row")}>
                <div className="h-100 d-flex align-items-start justify-content-center flex-column py-3">
                    <p className={`d-flex align-items-center justify-content-start ${isEn ? "gilroyFontFamily" : ""}`}>{paragraph}</p>
                    {link && linkTitle && (<HoverLink1 link={link} linkTitle={linkTitle} />)}
                </div>
                <div className="position-absolute" ref={divRef}></div>
                <Image
                    style={{
                        transform: isInView ? "none" : "translateY(-100px)",
                        opacity: isInView ? 1 : 0,
                        transition: "all ease 1400ms"
                    }}
                    src={imgaSrc}
                    alt={title}
                    unoptimized
                    width={100}
                    height={100}
                />
            </div>
        </div>
    )
}

export default StaticTopics
